import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

interface StyleObject {
  [key: string]: string;
}

/**
 * StyleProvider root component
 */
@customElement('style-provider')
export class StyleProvider extends LitElement {
  private readonly styleObject: StyleObject = {
    // Color styles
    '--primary-color': '#014E2A',
    '--background-color': 'white',
    '--menu-color': '#014E2A',
    '--dark-background-color': 'black',

    // Grey-ish
    '--text-color-main': '#2e2c2c',
    '--text-color-light': 'white',
  };

  constructor() {
    super();
    this.setBodyStyleObject(this.styleObject);
  }

  /**
   * Render function
   */
  public render() {
    return html`<slot></slot>`;
  }

  private readonly setBodyStyleObject = (object: StyleObject): void => {
    Object.keys(object).forEach((k: string) => {
      window.document.body.style.setProperty(k, object[k]);
    });
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'style-provider': StyleProvider;
  }
}
